module.exports = __webpack_public_path__ + "static/img/woman4.73e7fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/woman4.png
// module id = rLK3
// module chunks = 2